define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/promise/all",
	"dojo/store/Memory",
	"csi",
	"csi/api",
	"csi/_base/underscore",
	"csi/comm",
	"csi/def",
	"csi/def/Action",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/def/ViewRef",
	"csi/dgrid/MatrixEditorWithCheckBox",
	"csi/form/Widget",
	"csi/html",
	"csi/locale",
	"csi/reflection",
	"csi/store/_base",
	"csi/store/Names",
	"csi/resolver",
	"csi/xml",
	"csi/xml/Query",
	"./ProductType"
], function(declare, lang, all, Memory, csi, api, _, comm, def, Action, Field, Relationship, ViewRef, MatrixEditorWithCheckBox, Widget, html, locale, reflection, csiStore, Names, resolver, xml, Query, ProductType) {

	return declare(Widget, {
		'class': 'csi-form-view-block',

		USEMATRIX: "UseMatrix",
		AUTOGTIN: "AutoGTIN",
		colorsLabel: "RealizedColor",
		sizesLabel: "RealizedSize",
		fieldProduct: null,

		noColorSizeKey: csi.EMPTY_URL + "|" + csi.EMPTY_URL,

		hasProductColors: function(/*Product*/ product) {
			const activeColors = this.cacheView.getNodes(product.ProductColors).filter(n => n.Active);
			return this.defView.getField(this.colorsLabel) && ProductType.hasColor(product) && activeColors.length > 0;
		},

		hasProductSizes: function(/*Product*/ product) {
			return this.defView.getField(this.sizesLabel) && ProductType.hasSize(product) && product.ProductSizes.length > 0;
		},

		/**
		 * Determines if "Use Matrix" is currently active
		 * @return {boolean} - true if "Use Matrix" is active, otherwise false
		 */
		isUsingMatrix: function() {
			var useMatrixField = this.getField(this.USEMATRIX);
			return useMatrixField ? useMatrixField.getValue() : false;
		},

		/**
		 * @override
		 *
		 * Add ability to make matrix visible depending on form settings
		 */
		_updateFieldVisibility: function(field) {
			this._refreshFields();

			this.inherited(arguments);
		},

		/**
		 * @override
		 *
		 * Sizing of Matrix depends on form being visible, so us onResize event to add matrix as needed
		 */
		_onResize: function() {
			if (this.isUsingMatrix()) {
				this._addMatrix();
			}
		},

		_getRootRequest: function(/*Node*/node) {
			if (!this.isNew()) {
				return this.inherited(arguments);
			}

			// this logic only applies when copying or creating SKUs
			var product = this.defView.getSource().getParent();
			var nodeRequest = comm.getNodeRequest(product.$URL);
			return nodeRequest.addDependencyPaths(["Child:ProductColors;ProductSizes;RealizedProducts"]);
		},

		_getStoreOptions: function(/*Field*/ field) {
			return csiStore.namesOptionsByRelationship(this.getContext(), field.m_relationship);
		},

		/**
		 * Modified the store for field to display style dropdown values
		 * @param {Field} field- field on the form
		 * @param {string} value - value of the field
		 * @return {Store} - the store for field
		 */
		getFieldStore: function(field, value) {
			field = this.getField(field);
			switch (field.getControlName()) {
				case this.fieldProduct:
					var storeOptions = this._getStoreOptions(field);
					storeOptions.action = lang.mixin(new Action(), {
						m_viewRef: lang.mixin(new ViewRef(), {
							m_id: "AllStyles",
							m_url: "centric://APPAREL/Views"
						}),
						m_fixedQuery: new Query()
							.Attr("Active", xml.OP_EQUALS, true)
							.RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, this.defView.getSource().getParent().$URL)
					});
					return new Names(storeOptions);
				default:
					return this.inherited(arguments);
			}
		},

		_redraw: function() {
			this._removeMatrix();
			this.inherited(arguments);
		},

		/**
		 * Retrieves the WidgetParams for the Color/Size fields depending on customer Site settings
		 * @return {Object} - JS Object of widget params to use for fields
		 */
		_getColorSizeWidgetParams: function() {
			return api.getAllowNoneOptionForSKUCreation() ? {addItemAll: true} : {defaultAll: true};
		},

		_resolveView: function() {
			var colorField = this.defView.getField(this.colorsLabel);
			var sizeField = this.defView.getField(this.sizesLabel);

			var product = this.defView.getSource().getParent();
			var bHasColor = this.hasProductColors(product);
			var bHasSize = this.hasProductSizes(product);
			var gtin = resolver.resolveNode(reflection.URL_COMPANY);

			if (this.isNew()) {

				if (bHasColor) {
					colorField.m_typeControl = def.FIELD_MULTI_SELECT;
					colorField.widgetParams = this._getColorSizeWidgetParams();
				}

				if (bHasSize) {
					sizeField.m_typeControl = def.FIELD_MULTI_SELECT;
					sizeField.widgetParams = this._getColorSizeWidgetParams();
				}

				if (bHasColor || bHasSize) {
					this.insertField(lang.mixin(new Field(), {
						m_label: this.USEMATRIX,
						m_typeControl: def.FIELD_CHECKBOX,
						m_onChange: "_onChangeUseMatrix"
						// last param specifies which field to create this before
						// but the order of sizes/color between Style and Material is inverted, so
						// choose which field to appear before based on which product type is currently
						// being viewed
					}), product.$Type == "Style" ? this.sizesLabel : this.colorsLabel);
				}

			}

			if (this.isNew() || this.isCopy()) {
				//Adding AutoGTIN checkbox for New and Copy form
				if (product.$Type == "Style" && xml.isValidURL(gtin.DefaultManufacturerCode)) {
					this.insertField(lang.mixin(new Field(), {
						m_label: this.AUTOGTIN,
						m_typeControl: def.FIELD_CHECKBOX,
						bPersist: true
					}));
					//Adding Styles field for MassCreateSKUs on Collection level Tab.
				} else if (product.$Type == "Collection") {
					this.fieldProduct = "Styles";
					var q = new Query()
						.Attr("Active", xml.OP_EQUALS, true)
						.RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, product.$URL);
					this.insertField(lang.mixin(new Field(), {
						m_label: this.fieldProduct,
						m_typeControl: def.FIELD_MULTI_SELECT,
						m_bRequired: true,
						idParameter: this.fieldProduct,
						widgetParams: {defaultAll: true},
						m_relationship: lang.mixin(new Relationship(), {
							m_typeNode: "Style",
							m_query: q
						})
					}), 1);
				}
			}
			this.inherited(arguments);
		},

		/**
		 * Handles show/hide of matrix when value changes
		 */
		_onChangeUseMatrix: function(defView, field, value) {
			if (value) {
				this._addMatrix();
			} else {
				this._removeMatrix();

				//Added below codes to make color and size field default to select all.
				var colorField = this.defView.getField(this.colorsLabel);
				var sizeField = this.defView.getField(this.sizesLabel);

				var product = this.defView.getSource().getParent();
				var bHasColor = this.hasProductColors(product);
				var bHasSize = this.hasProductSizes(product);

				if (bHasColor) {
					colorField.m_control.set("value", 0);
				}
				if (bHasSize) {
					sizeField.m_control.set("value", 0);
				}
			}
		},

		_refreshFields: function() {
			var product = this.defView.getSource().getParent();
			var bHasColor = this.hasProductColors(product);
			var bHasSize = this.hasProductSizes(product);
			var useMatrixValue = this.isUsingMatrix();

			this.setFieldHidden(this.colorsLabel, useMatrixValue || !bHasColor);
			this.setFieldHidden(this.sizesLabel, useMatrixValue || !bHasSize);
		},

		_addMatrix: function() {
			if (this._matrixRow || !this.bodyNode.offsetHeight) {
				return;
			}

			var product = this.defView.getSource().getParent();
			var bHasColor = this.hasProductColors(product);
			var bHasSize = this.hasProductSizes(product);

			var bColumns = (bHasColor && bHasSize);
			var cache = this.cacheView;

			// determine cell data to determine which colors and/or sizes are present
			var cellData = [];

			_.each(cache.getNodes(product.RealizedProducts), function(realizedProdNode) {
				var rowKey, colKey;
				if (!bColumns && bHasSize) {
					// only has size, so assign from realized size
					rowKey = realizedProdNode.RealizedSize;
				} else if (bHasColor) {
					rowKey = realizedProdNode.RealizedColor;
					if (bColumns) {
						colKey = realizedProdNode.RealizedSize;
					}
				}

				if (rowKey) {
					var item = {
						id: realizedProdNode.$URL,
						name: realizedProdNode.$Name,
						color: realizedProdNode.RealizedColor,
						size: realizedProdNode.RealizedSize
					};

					if (!cellData[rowKey]) {
						cellData[rowKey] = [];
					}

					if (colKey) {
						if (!cellData[rowKey][colKey]) {
							cellData[rowKey][colKey] = [];
						}
						cellData[rowKey][colKey].push(item);
					} else {
						cellData[rowKey].push(item);
					}
				}
			});

			this._matrixRow = this._createFieldDom();

			// form using csi-form-view-block is using display:block, so no need to create th or td
			var domNode = html.create('div', {style: 'padding-top: 6px;'}, this._matrixRow);

			// C8-14486
			// when creating the data stores for the matrix columns and rows, copy the data from
			// the already existing field stores so the correct names and sorting get used
			function _createMatrixStoreFromFieldDataStore(results, store) {
				var idProperty = store.idProperty;
				var labelProperty = store.labelProperty;
				return new Memory({
					labelProperty: "name",
					data: csi.transform(results, function(item) {
						var id = item[idProperty];
						return (id != csi.DIALOG_URL) ? {id: id, name: item[labelProperty]} : null;
					})
				});
			}

			var colorFieldStore = this.getFieldStore(this.colorsLabel, []);
			var sizeFieldStore = this.getFieldStore(this.sizesLabel, []);

			var dfds = [];

			var rowList = null;
			if (bHasColor) {
				rowList = this.colorsLabel;
				dfds.push(colorFieldStore.query());
			} else {
				rowList = this.sizesLabel;
				dfds.push(sizeFieldStore.query());
			}

			var colList = null;
			if (bColumns) {
				colList = this.sizesLabel;
				dfds.push(sizeFieldStore.query());
			}

			function getSkus(/*String*/ rowId, /*String*/ columnId) {
				return cellData[rowId] ? (columnId ? cellData[rowId][columnId] : cellData[rowId]) : null;
			}

			function hasSkuForEveryColumn(/*String*/ rowId) {
				var rowData = cellData[rowId];
				return rowData && _.every(colList, function(colItem) {
					return !!rowData[colItem];
				});
			}

			function hasSkuForEveryRow(/*String*/ columnId) {
				return _.every(rowList, function(rowItem) {
					return cellData[rowItem] && cellData[rowItem][columnId];
				});
			}

			function hasAllSkus() {
				// this is Select All case, so see if all items are checked
				return _.every(rowList, function(rowItem) {
					return cellData[rowItem] && _.every(colList, function(colItem) {
						return !!cellData[rowItem][colItem];
					});
				});
			}

			function _editorArgsCallback(/*Object */args, /*Object*/ row,/*Object*/ column) {
				if (row && column) {
					var skus = getSkus(row.id, column.id);
					if (skus) {
						args.title = _.pluck(skus, "name").join(", ");
						args.disabled = true;
						args.value = true;
					} else {//Added this else statement to make matrix check boxes default to select all.
						args.value = true;
					}
				} else if (row && hasSkuForEveryColumn(row.id)) {
					var skus = getSkus(row.id);
					args.title = _.pluck(skus, "name").join(", ");
					args.disabled = true;
					args.value = true;
				} else if (column && hasSkuForEveryRow(column.id)) {
					args.disabled = true;
					args.value = true;
				} else if (hasAllSkus()) {
					args.disabled = true;
					args.value = true;
				} else {//Added this else statement to make matrix check boxes default to select all.
					args.value = true;
				}
			}

			this.when(all(dfds), results => {
				// matrix should always default to 0
				this._matrix = new MatrixEditorWithCheckBox({
					label: locale.resource("SizeMapSelectAll"),
					columnLabel: bColumns ? locale.resource(this.sizesLabel) : '',
					columnStore: results[1] ? _createMatrixStoreFromFieldDataStore(results[1], sizeFieldStore) : null,
					rowLabel: locale.resource(bHasColor ? this.colorsLabel : this.sizesLabel),
					rowStore: _createMatrixStoreFromFieldDataStore(results[0], bHasColor ? colorFieldStore : sizeFieldStore),
					editorArgsCallback: _editorArgsCallback
				}).placeAt(domNode);
			});
		},

		_removeMatrix: function() {
			html.destroyElement(this._matrixRow);
			this._matrixRow = null;
			this._matrix = null;
		},

		getColorSKUHashKey: function(/*String*/color,/*String*/size) {
			return (color == null ? csi.EMPTY_URL : color) + "|" + (size == null ? csi.EMPTY_URL : size);
		},

		getExistingSKUs: function() {
			var product = this.defView.getSource().getParent();
			var skus = this.cacheView.getNodes(product.RealizedProducts);
			var self = this;
			return csi.hashArray(skus, function(node) {
				return self.getColorSKUHashKey(node.RealizedColor, node.RealizedSize);
			}, Boolean);
		},

		getSelectedColorSizePairs: function() {
			var pairs = [];
			if (!this.isNew())
				return pairs;

			var product = this.defView.getSource().getParent();
			var bHasColor = this.hasProductColors(product);
			var bHasSize = this.hasProductSizes(product);

			var self = this;

			if (this.isUsingMatrix()) {
				var matrix = this._matrix;
				var matrixValues = matrix.get("value");
				var curColSizeValues = this.getExistingSKUs();

				matrix.rowStore.query().forEach(function(item, i) {
					var id = item.id;
					var values = matrixValues[i];
					if (bHasColor && bHasSize) {
						var sizeResults = matrix.columnStore.query();
						sizeResults.forEach(function(size, i) {
							if (values[i]) {
								if (!curColSizeValues[self.getColorSKUHashKey(id, size.id)]) {
									pairs.push({c: id, s: size.id});
								}
							}
						});
					} else if (values[0]) {
						if (bHasColor) {
							if (!curColSizeValues[self.getColorSKUHashKey(id, null)]) {
								pairs.push({c: id});
							}
						} else if (bHasSize) {
							if (!curColSizeValues[self.getColorSKUHashKey(null, id)]) {
								pairs.push({s: id});
							}
						}
					}
				}, this);
			} else {
				// get selected sizes / colors
				var colors = this.getFormData().getFieldValue(this.colorsLabel, true) || [];
				var sizes = this.getFormData().getFieldValue(this.sizesLabel, true) || [];

				var bHasColorsSel = bHasColor && colors.length > 0;
				var bHasSizesSel = bHasSize && sizes.length > 0;

				if (bHasColorsSel && bHasSizesSel) {
					// loop through both Sizes / Colors
					colors.forEach(function(curProductColor) {
						_.each(product.ProductSizes, function(curProductSize) {
							if (_.contains(sizes, curProductSize)) {
								pairs.push({c: curProductColor, s: curProductSize});
							}
						});
					});
				} else if (bHasColorsSel) {
					colors.forEach(function(curProductColor) {
						pairs.push({c: curProductColor});
					});
				} else if (bHasSizesSel) {
					_.each(product.ProductSizes, function(curProductSize) {
						if (_.contains(sizes, curProductSize)) {
							pairs.push({s: curProductSize});
						}
					});
				}

				if (!pairs.length) {
					// no color/size, just add an empty entry to force creating a new SKU
					pairs.push({});
				}
			}

			return pairs;
		}
	});
});
